import { FC } from 'react';
import './ReportSummaryCard.scss';

export interface ReportSummaryCardProps {
  title: string;
  value: string | number;
  subtext?: string;
  valueHighlight?: boolean;
}

const ReportSummaryCard: FC<ReportSummaryCardProps> = ({
  title,
  value,
  subtext,
  valueHighlight = false,
}) => (
  <div className={`card report-summary-card ${valueHighlight ? 'report-summary-card--highlight' : ''}`}>
    <div className="report-summary-card__title">{title}</div>
    <div className="report-summary-card__value">{value}</div>
    {subtext != null && subtext !== '' && (
      <div className="report-summary-card__subtext">{subtext}</div>
    )}
  </div>
);

export default ReportSummaryCard;
